import React from 'react';
import { ImageOutlined, SlideshowOutlined, TvOutlined, PlaylistPlayOutlined, OndemandVideoOutlined } from '@mui/icons-material';
import { SideBarItems } from 'components/Sidebar';
import { Assets } from './Assets';
import { ReelMaker } from './ReelMaker';
import { ManageScreens } from './ManageScreens';
import { OnDemandPlayer } from './OnDemandPlayer';
import { Playlists } from './Playlists';
import { BeamOnScreenSidebarIcon } from './BeamOnScreenSidebarIcon';

const buildItems = (menuKey: 'campaignKing' | 'instantUpdate'): SideBarItems[] => [{
    path: '/',
    urlKey: 'beamonscreen',
        text: 'Beam on Screen',
    icon: <BeamOnScreenSidebarIcon />,
    type: 'menuHeader',
    menuKey,
    requiredModule: 'beamonscreen.com',
    dictionaryKey: 'sidebar-menu-beamonscreen',
    items: [
        {
            path: '/beamonscreen/',
            urlKey: 'assets',
            text: 'Assets',
            icon: <ImageOutlined />,
            type: 'menuItem',
            menuKey,
            module: <Assets />,
            requiredModule: 'beamonscreen.com',
            dictionaryKey: 'sidebar-menu-beamonscreen-assets',
        },
        {
            path: '/beamonscreen/',
            urlKey: 'reel-maker',
            text: 'Reel Maker',
            icon: <SlideshowOutlined />,
            type: 'menuItem',
            menuKey,
            module: <ReelMaker />,
            requiredModule: 'beamonscreen.com',
            dictionaryKey: 'sidebar-menu-beamonscreen-reel-maker',
        },
        {
            path: '/beamonscreen/',
            urlKey: 'manage-screens',
            text: 'Manage Screens',
            icon: <TvOutlined sx={{ transform: 'rotate(90deg)' }} />,
            type: 'menuItem',
            menuKey,
            module: <ManageScreens />,
            requiredModule: 'beamonscreen.com',
            requiredRole: 'admin',
            dictionaryKey: 'sidebar-menu-beamonscreen-manage-screens',
        },
        {
            path: '/beamonscreen/',
            urlKey: 'ods',
            text: 'On Demand Player',
            icon: <OndemandVideoOutlined />,
            type: 'menuItem',
            menuKey,
            module: <OnDemandPlayer />,
            requiredModule: 'beamonscreen.com',
            requiredRole: 'admin',
            dictionaryKey: 'sidebar-menu-beamonscreen-on-demand-player',
        },
        {
            path: '/beamonscreen/',
            urlKey: 'playlists',
            text: 'Playlists',
            icon: <PlaylistPlayOutlined />,
            type: 'menuItem',
            menuKey,
            module: <Playlists />,
            requiredModule: 'beamonscreen.com',
            dictionaryKey: 'sidebar-menu-beamonscreen-playlists',
        },
    ]
}];

export const ModulesMenu: SideBarItems[] = [
    ...buildItems('campaignKing'),
];
